import React from 'react';

const ScrollWrapper = ({ children }) => {
    return (
        <div className="flex-1 min-h-0" >
            <div className="w-full rounded-md overflow-hidden flex flex-col mt-4 h-full">
                <div className="flex-1 overflow-auto hide-scrollbar pb-20">
                    {children}
                </div>
            </div>
        </div>
    );
};


export default ScrollWrapper;